import { Skeleton, Stack, Typography } from '@mui/material';
import PlanCard from '../cards/PlanCard';
import { useGetSubscriptionPlans } from '@/hooks/api/subscription';
import EmptyContent from '../common/EmptyContent';

const PlanItems = ({ discount = 0, showGifts = false }) => {
  const { data, isLoading, isError } = useGetSubscriptionPlans();

  if (isLoading)
    return (
      <>
        <Skeleton height="300px" variant="rounded" />
        <Skeleton height="500px" variant="rounded" />
      </>
    );

  if (isError)
    return (
      <EmptyContent>
        <Typography variant="body2" color="text.secondary">
          خطایی به وجود آمده است
        </Typography>
      </EmptyContent>
    );

  return (
    <Stack
      direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
      sx={{
        justifyContent: 'center',

        alignItems: {
          xs: 'center',
          sm: 'center',
          md: 'center',
          lg: 'flex-end',
        },
        gap: 3,
      }}>
      <PlanCard
        plan={data?.small}
        discount={discount}
        features={[
          `${data.small?.capacity} گیگ فضای ذخیره سازی`,
          'استریم مستقیم ار داخل دوره ساز',
          `هر گیگ فضای اضافه ${data.small?.eachGigabytes} تومان`,
          'غیر قابل دانلود شدن دوره ها',
          `کارمزد تا سقف ${data.small?.commission} از فروش هر دوره`,
        ]}
      />
      <PlanCard
        recommended
        activeGift={showGifts}
        plan={data.medium}
        discount={discount}
        features={[
          'تمام امکانات پلن پایه',
          `${data.medium?.capacity} گیگ فضای ذخیره سازی`,
          'مدیریت دانشجویان(CRM)',
          'ایجاد وب سایت برای مدرس (صفحه شخصی)',
          'گزارش گیری دقیق و نظارت بر رفتار دانشجویان',
          'نرم افزار اختصاصی برای ویندوز، اندروید و ایفون',
          'تشخیص هوشمند مهاجمین با هوش مصنوعی ',
          `هر گیگ فضای اضافه ${data.medium?.eachGigabytes} تومان`,
          `کارمزد تا سقف ${data.medium?.commission} از فروش هر دوره`,
        ]}
      />
      <PlanCard
        plan={data.large}
        discount={discount}
        features={[
          'تمامی امکانات پلن حرفه ای',
          `${data.large?.capacity} گیگ فضای ذخیره سازی`,
          'پشتیبانی و مشاوره تخصصی برای  فروش بیشتر',
          `هر گیگ فضای اضافه ${data.large?.eachGigabytes} تومان`,
          `کارمزد تا سقف ${data.large?.commission} از فروش هر دوره`,
        ]}
      />
    </Stack>
  );
};

export default PlanItems;
